import React from 'react';
import { Row } from 'reactstrap';
import CardLocation from './cardLocation';

const CardDetail = ({
	name, age, gender, location, style
}) => (
	<div style={style}>
		<Row>
			<h6 className="mb-1 primary-color"> {name} </h6>
		</Row>
		<Row>
			<span className="small-text mid-grey mr-auto">
				{age}{typeof age === 'undefined' || age === null || age === '' || typeof gender === 'undefined' || gender === null || gender === '' ? '' : ' , '}{gender}
			</span>
			{typeof location !== 'undefined' ?
			<CardLocation
				className="ml-auto small-text mid-grey"
				location={location}
				gap="2px"
				size="0.75rem"
			/>
			:
			null }
		</Row>
	</div>
);

export default CardDetail;
